import React from "react";
import "./FooterCss.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        Мамба одобрил ©
      </div>
    </footer>
  );
}